module.exports = __webpack_public_path__ + "static/3.1-Number_1_icon-01-0e019b1d6509c0ca5fd710957b9a5ba8.png";